<template>
    <div class="d-flex flex-row align-items-center border rounded mb-2 original-load-info" style="padding: 4px;">
        <div class="d-flex align-items-center" style="margin-left: 80px; margin-right: 160px;">
            <BaseIcon name="info" size="24" style="margin-right: 8px; color: #AEC8F3;"></BaseIcon>
            <div class="size-md"><b>Original Load Info</b></div>
        </div>
        <div class="d-flex flex-column" style="margin-right: 50px;">
            <div class="size-sm"><b>Pickup Date</b></div>
            <div class="size-md">Estimated {{ order.pickupDate | formatDate }}</div>
        </div>
        <div class="d-flex flex-column" style="margin-right: 50px;">
            <div class="size-sm"><b>Delivery Date</b></div>
            <div class="size-md">Estimated {{ order.deliveryDate | formatDate }}</div>
        </div>
        <div class="d-flex flex-column" style="margin-right: 50px;">
            <div class="size-sm"><b>Transport type</b></div>
            <div class="size-md">{{ order.transportType.title }} </div>
        </div>
        <div class="d-flex flex-column">
            <div class="size-sm"><b>Carrier Pay</b></div>
            <div class="size-lg"><b>${{ order.carrierPay || 'Not Set' }}</b></div>
        </div>
    </div> 
</template>

<script>
import BaseIcon from '@/components/shared/BaseIcon.vue';

export default {
    name: 'OriginalLoadInfo',
    components: { BaseIcon },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style>
.size-lg {
    font-size: 18px;
}
.size-md {
    font-size: 14px;
}
.size-sm {
    font-size: 12px;
}
.original-load-info{
    background-color: #EBF2FE; 
    border-color: #D8E5FD;
    color: #4E5155;
}
.dark-style .original-load-info{
    background-color: #30486C; 
    border-color: #3F5B83;
    color: #FFFFFF;
}
</style>